<template>
  <div>
    <el-page-header @back="goBack" content="活动药品管理"> </el-page-header>
    <el-card style="width: 1400px; margin: 30px auto 0">
      <el-row :gutter="20">
        <el-col :span="5">
          <el-input
            v-model="ypmc"
            placeholder="请输入药品名称"
            size="medium"
            clearable
            @keyup.enter.native="getByDrug"
          ></el-input>
        </el-col>
        <el-col :span="5">
          <el-input
            v-model="cdmc"
            placeholder="请输入产地名称"
            size="medium"
            clearable
            @keyup.enter.native="getByDrug"
          ></el-input>
        </el-col>
        <el-col :span="5">
          <el-input
            v-model="gg"
            placeholder="请输入药品规格"
            size="medium"
            clearable
            @keyup.enter.native="getByDrug"
          ></el-input>
        </el-col>
        <el-col :span="1.5">
          <el-button type="primary" size="medium" @click="getByDrug"
            >查询</el-button
          >
        </el-col>
        <el-col :span="1.5">
          <el-button type="success" size="medium" @click="addByDrug"
            >添加活动药品</el-button
          >
        </el-col>
        <el-col :span="1.5">
          <el-button type="danger" size="medium" @click="deleteChiose"
            >选中删除</el-button
          >
        </el-col>
      </el-row>
      <el-table
        :data="dataByDrug"
        style="width: 100%; margin-top: 20px"
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" align="center">
        </el-table-column>
        <el-table-column label="药品图片" width="105" align="center">
          <template slot-scope="scope">
            <el-popover placement="right" width="245" trigger="hover">
              <img
                :src="base + scope.row.image"
                alt="图片加载错误"
                style="width: 220px; height: 220px"
              />
              <img
                slot="reference"
                :src="base + scope.row.image"
                alt="图片加载错误"
                style="width: 80px; height: 80px"
              />
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          prop="ypmc"
          label="药品名称"
          header-align="center"
          width="140"
        >
        </el-table-column>
        <el-table-column
          prop="cdmc"
          label="产地名称"
          header-align="center"
          width="140"
        >
        </el-table-column>
        <el-table-column prop="gg" label="规格" align="center" width="100">
        </el-table-column>
        <el-table-column prop="boss" label="代理商号" align="center" width="80">
        </el-table-column>
        <el-table-column prop="dj" label="原价" align="center" width="80">
        </el-table-column>
        <el-table-column prop="tgdj" label="活动单价" align="center" width="80">
        </el-table-column>
        <el-table-column
          prop="tgdj2"
          label="真实单价"
          align="center"
          width="80"
        >
        </el-table-column>
        <el-table-column prop="ph" label="批号" align="center" width="90">
        </el-table-column>
        <el-table-column prop="sl" label="库存" align="center" width="70">
        </el-table-column>
        <el-table-column
          prop="topindex"
          label="置顶数"
          align="center"
          width="70"
        >
        </el-table-column>
        <el-table-column
          prop="isretail"
          label="零/整"
          align="center"
          width="70"
        >
          <template slot-scope="scope">
            {{ scope.row.isretail ? "零" : "整" }}
          </template>
        </el-table-column>
        <el-table-column prop="stepnum" label="步长" align="center" width="80">
        </el-table-column>
        <el-table-column
          prop="zxnum"
          label="最小购买数量"
          align="center"
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="ytnum"
          label="已购数量"
          align="center"
          width="80"
        >
        </el-table-column>
        <el-table-column label="是否上架" width="80" align="center">
          <template slot-scope="scope">
            <div>
              <el-switch
                v-model="scope.row.drugstate"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :active-value="1"
                :inactive-value="0"
                @change="changeState(scope.row)"
              >
              </el-switch>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="yxq" label="有效期" width="90" align="center">
        </el-table-column>
        <el-table-column prop="scrq" label="生产日期" width="90" align="center">
        </el-table-column>
        <el-table-column prop="pzwh" label="批准文号" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center" width="200" fixed="right">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-edit"
              @click="handleEdit(scope.row)"
            ></el-button>
            <el-button type="success" size="mini" @click="handleTop(scope.row)"
              >置顶</el-button
            >
            <el-button
              type="danger"
              size="mini"
              icon="el-icon-delete"
              @click="handleDelete(scope.row)"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="SizeChange"
        @current-change="CurrentChange"
        :current-page="pageIndex"
        :page-sizes="[10, 20]"
        :page-size="pageSize"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
    <el-dialog
      :title="isAdd ? '添加活动药品' : '修改活动药品'"
      :visible.sync="dialogByDrug"
      :width="'900px'"
      center
      :close-on-click-modal="false"
    >
      <el-form :model="formByDrug" label-width="120px">
        <el-form-item label="药品名称：">
          <el-input
            v-model="formByDrug.ypmc"
            style="width: 60%"
            disabled
          ></el-input>
          <el-button
            type="success"
            style="margin-left: 30px"
            v-if="isAdd"
            @click="chioseDrug"
            >选择药品</el-button
          >
        </el-form-item>
        <el-form-item label="产地名称：">
          <el-input v-model="formByDrug.cdmc" disabled></el-input>
        </el-form-item>
        <el-form-item label="规格：">
          <el-input v-model="formByDrug.gg" disabled></el-input>
        </el-form-item>
        <el-form-item label="批准文号：">
          <el-input v-model="formByDrug.pzwh" disabled></el-input>
        </el-form-item>
        <el-form-item label="批号：">
          <el-input v-model="formByDrug.ph" disabled></el-input>
        </el-form-item>
        <el-form-item label="库存：" v-if="isAdd">
          <el-input v-model="formByDrug.sl" disabled></el-input>
        </el-form-item>
        <el-form-item label="活动单价：" class="is-required">
          <el-input v-model="formByDrug.dj"></el-input>
        </el-form-item>
        <el-form-item label="生产日期：">
          <el-input v-model="formByDrug.scrq" disabled></el-input>
        </el-form-item>
        <el-form-item label="有效期：">
          <el-input v-model="formByDrug.yxq" disabled></el-input>
        </el-form-item>
        <el-form-item label="步长：">
          <el-input v-model="formByDrug.stepnum" disabled></el-input>
        </el-form-item>
        <el-form-item label="最小购买数量：" class="is-required">
          <el-input v-model="formByDrug.zxnum"></el-input>
        </el-form-item>
        <el-form-item label="已购数量：" class="is-required">
          <el-input v-model="formByDrug.ytnum"></el-input>
        </el-form-item>
        <el-form-item label="已购数量：">
          <el-input v-model="formByDrug.ytnum"></el-input>
        </el-form-item>
        <el-form-item label="零/整：">
          <el-radio-group v-model="formByDrug.isretail" disabled>
            <el-radio :label="0">整货</el-radio>
            <el-radio :label="1">零货</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="置顶数" class="is-required" v-if="isAdd">
          <el-input v-model="formByDrug.topindex"></el-input>
        </el-form-item>
        <el-form-item label="是否上架：" class="is-required">
          <el-radio-group v-model="formByDrug.drugstate">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="上传图片：" class="is-required">
          <el-upload
            action=""
            list-type="picture-card"
            :limit="1"
            :file-list="fileList"
            :on-exceed="handleExceed"
            :on-remove="handleRemove"
            :http-request="uploadFile"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogByDrug = false">取 消</el-button>
        <el-button type="primary" @click="submitUp">确 定</el-button>
      </div>
      <el-dialog
        title="选择团购药品"
        :visible.sync="dialogDrug"
        :width="'1300px'"
        :close-on-click-modal="false"
        append-to-body
        center
      >
        <div>
          <el-row :gutter="20">
            <el-col :span="5">
              <el-input
                v-model="Dypmc"
                placeholder="请输入药品名称"
                size="medium"
                clearable
                @keyup.enter.native="getDrug"
              ></el-input>
            </el-col>
            <el-col :span="5">
              <el-input
                v-model="Dcdmc"
                placeholder="请输入产地名称"
                size="medium"
                clearable
                @keyup.enter.native="getDrug"
              ></el-input>
            </el-col>
            <el-col :span="5">
              <el-input
                v-model="Dgg"
                placeholder="请输入药品规格"
                size="medium"
                clearable
                @keyup.enter.native="getDrug"
              ></el-input>
            </el-col>
            <el-col :span="1.5">
              <el-button type="primary" size="medium" @click="getDrug"
                >查询</el-button
              >
            </el-col>
          </el-row>
          <el-table
            :data="dataDrug"
            style="width: 100%; margin-top: 20px"
            border
          >
            <el-table-column prop="ypmc" label="药品名称" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="cdmc" label="产地名称" show-overflow-tooltip>
            </el-table-column>
            <el-table-column
              prop="gg"
              label="药品规格"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="boss"
              label="BOSS号"
              align="center"
              width="80"
            >
            </el-table-column>
            <el-table-column prop="dj" label="单价" align="center" width="80">
            </el-table-column>
            <el-table-column prop="sl" label="库存" align="center" width="80">
            </el-table-column>
            <el-table-column
              prop="zbz"
              label="中包装"
              align="center"
              width="80"
            >
            </el-table-column>
            <el-table-column prop="bz" label="包装" align="center" width="80">
            </el-table-column>
            <el-table-column
              prop="isretail"
              label="零/整"
              align="center"
              width="80"
            >
              <template slot-scope="scope">
                <div>
                  {{ scope.row.isretail ? "零" : "整" }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="scrq"
              label="生产日期"
              align="center"
              width="90"
            >
            </el-table-column>
            <el-table-column
              prop="yxq"
              label="有效期"
              align="center"
              width="90"
            >
            </el-table-column>
            <el-table-column prop="pzwh" label="批准文号" show-overflow-tooltip>
            </el-table-column>
            <el-table-column align="center" label="操作" width="80">
              <template slot-scope="scope">
                <el-button
                  type="success"
                  size="mini"
                  @click="determine(scope.row)"
                  >选择</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="drugSizeChange"
            @current-change="drugCurrentChange"
            :current-page="DrugIndex"
            :page-sizes="[10, 20]"
            :page-size="DrugSize"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="DrugTotal"
          >
          </el-pagination>
        </div>
        <div slot="footer">
          <el-button @click="dialogDrug = false">取 消</el-button>
          <el-button type="primary" @click="dialogDrug = false"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </el-dialog>
    <el-dialog
      title="置顶药品"
      :visible.sync="dialogTop"
      :width="'600px'"
      center
      :close-on-click-modal="false"
    >
      <div>
        <el-form :model="formTop" label-width="100px">
          <el-form-item label="置顶数：" class="is-required">
            <el-input v-model="formTop.topindex"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button @click="dialogTop = false">取 消</el-button>
        <el-button type="primary" @click="submitTop">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tgid: 0,
      pageIndex: 1,
      pageSize: 20,
      base: "http://fw.hyey.cn",
      ypmc: "",
      cdmc: "",
      gg: "",
      total: 0,
      isAdd: false,
      dialogByDrug: false,
      formByDrug: {
        ypmc: "",
        cdmc: "",
        gg: "", 
        pzwh: "",
        ph: "",
        stepnum: 0,
        zxnum: 0,
        dj: 0,
        sl: 0,
        scrq: "",
        isretail: 0,
        yxq: "",
        image: "",
        tgid: 0,
        drugstate: 0,
        drugid: "",
        topindex: 0,
        ytnum: 0,
        lx:3
      },
      dialogDrug: false,
      Dypmc: "",
      Dcdmc: "",
      Dgg: "",
      dataDrug: [],
      DrugIndex: 1,
      DrugSize: 20,
      DrugTotal: 0,
      fileList: [],
      initForm: {},
      dataByDrug: [],
      multipleSelection: [],
      dialogTop: false,
      formTop: {
        id: 0,
        state: 0,
        drugid: "",
        topindex: 0,
      },
    };
  },
  mounted() {
    this.tgid = this.$route.params.byid;
    this.initForm = { ...this.formByDrug };
    this.getByDrug();
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    // 查询团购药品
    getByDrug() {
      this.pageIndex = 1;
      this.searchByDrug();
    },
    // 获取团购药品
    searchByDrug() {
      if (!this.tgid) {
        setTimeout(() => {
          this.goBack();
        }, 1000);
      } else {
        this.$http
          .post("DsApi/GetSearchList", {
            pageIndex: this.pageIndex,
            pageSize: this.pageSize,
            keys: this.ypmc,
            cdmc: this.cdmc,
            gg: this.gg,
            action: "Tgdrug",
            id: this.tgid,
            lx:3
          })
          .then((res) => {
            if (res.data.isok) {
              this.dataByDrug = res.data.data;
              this.total = res.data.recount;
            }
          });
      }
    },
    // 添加团购药品
    addByDrug() {
      this.isAdd = true;
      this.formByDrug = { ...this.initForm };
      this.fileList = [];
      this.dialogByDrug = true;
    },
    // 编辑团购药品
    handleEdit(rows) {
      this.isAdd = false;
      
      this.formByDrug = { ...this.initForm };
      this.formByDrug.id = rows.id;
      this.formByDrug.ypmc = rows.ypmc;
      this.formByDrug.cdmc = rows.cdmc;
      this.formByDrug.gg = rows.gg;
      this.formByDrug.pzwh = rows.pzwh;
      this.formByDrug.ph = rows.ph;
      this.formByDrug.stepnum = rows.stepnum;
      this.formByDrug.zxnum = rows.zxnum;
      this.formByDrug.dj = rows.tgdj;
      this.formByDrug.sl = rows.sl;
      this.formByDrug.scrq = rows.scrq;
      this.formByDrug.yxq = rows.yxq;
      this.formByDrug.image = rows.image;
      this.formByDrug.isretail = rows.isretail;
      this.formByDrug.drugstate = rows.drugstate;
      this.formByDrug.drugid = rows.drugid;
      this.formByDrug.topindex = rows.topindex;
      this.formByDrug.ytnum = rows.ytnum;
      if (rows.image) {
        this.fileList = [];
        let images = { url: this.base + rows.image };
        this.fileList.push(images);
      } else {
        this.fileList = [];
      }
      this.dialogByDrug = true;
      
    },
    // 删除药品
    handleDelete(rows) {
      this.$confirm("此操作将会永久删除这个团购药品, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.DelByDrug(rows.id + "");
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 删除选中
    deleteChiose() {
      if (this.multipleSelection.length == 0) {
        this.$message.error("对不起，您还未选中团购药品！");
      } else {
        let id = this.multipleSelection.join();
        this.$confirm("此操作将永久删除这些团购药品, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.DelByDrug(id);
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      }
    },
    //置顶
    handleTop(rows) {
      this.formTop.id = rows.id;
      this.formTop.state = rows.state;
      this.formTop.drugid = rows.id;
      this.formTop.topindex = rows.topindex;
      this.dialogTop = true;
    },
    // 置顶团购药品
    submitTop() {
      this.$http.post("DsApi/UpdateDrugIndex", this.formTop).then((res) => {
        if (res.data.isok) {
          this.$message.success(res.data.message);
          this.searchByDrug();
          this.dialogTop = false;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    //删除团购活动请求
    DelByDrug(id) {
      this.$http
        .post("DsApi/DelTgDrug", {
          id,
        })
        .then((res) => {
          if (res.data.isok) {
            this.$message.success(res.data.message);
            this.searchByDrug();
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    // 选择团购药品
    chioseDrug() {
      this.getDrug();
      this.dialogDrug = true;
    },
    // 修改/添加团购药品
    submitUp() {
      this.formByDrug.tgid = this.tgid;
      if (this.isAdd) {
        if (this.formByDrug.ypmc == "") {
          this.$message.warning("对不起，您还未选择药品！");
        } else if (this.formByDrug.stepnum == 0) {
          this.$message.warning("对不起，最小购买数量不能为0！");
        } else {
          this.$http.post("DsApi/AddTgDrug", this.formByDrug).then((res) => {
            if (res.data.isok) {
              this.$message.success(res.data.message);
              this.dialogByDrug = false;
              this.searchByDrug();
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      } else {
        this.$http.post("DsApi/UpdateTgDrug", this.formByDrug).then((res) => {
          if (res.data.isok) {
            this.$message.success(res.data.message);
            this.dialogByDrug = false;
            this.searchByDrug();
          } else {
            this.$message.error(res.data.message);
          }
        });
      }
    },
    // 上下架团购药品
    changeState(rows) {
      this.$http
        .post("DsApi/UpdownTgDrug", {
          id: rows.id,
          state: rows.drugstate,
          drugid: rows.id,
        })
        .then((res) => {
          if (res.data.isok) {
            this.$message.success(res.data.message);
            this.searchByDrug();
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    //当多选框被选择时
    handleSelectionChange(val) {
      this.multipleSelection = val.map((item) => {
        return item.id;
      });
    },
    //查询基础药品信息
    getDrug() {
      this.DrugIndex = 1;
      this.searchDrug();
    },
    // 获取基础药品信息
    searchDrug() {
      this.$http
        .post("DsApi/GetSearchList", {
          pageIndex: this.DrugIndex,
          pageSize: this.DrugSize,
          keys: this.Dypmc,
          cdmc: this.Dcdmc,
          gg: this.Dgg,
          action: "alldrug",
        })
        .then((res) => {
          if (res.data.isok) {
            this.dataDrug = res.data.data;
            this.DrugTotal = res.data.recount;
          }
        });
    },
    // 选择基础药品信息
    determine(rows) {
      this.formByDrug.ypmc = rows.ypmc;
      this.formByDrug.cdmc = rows.cdmc;
      this.formByDrug.gg = rows.gg;
      this.formByDrug.ph = rows.ph;
      this.formByDrug.pzwh = rows.pzwh;
      this.formByDrug.scrq = rows.scrq;
      this.formByDrug.yxq = rows.yxq;
      this.formByDrug.dj = rows.dj;
      this.formByDrug.sl = rows.sl;
      this.formByDrug.drugid = rows.id;
      this.formByDrug.isretail = rows.isretail;
      if (rows.isretail == 0) {
        this.formByDrug.stepnum = rows.bz;
        this.formByDrug.zxnum = rows.bz;
      } else {
        this.formByDrug.stepnum = rows.zbz;
        this.formByDrug.zxnum = rows.zbz;
      }
      this.dialogDrug = false;
    },
    // 所有药品Size发生改变时
    drugSizeChange(val) {
      this.DrugSize = val;
      this.searchDrug();
    },
    // 团购药品Size发生改变时
    SizeChange(val) {
      this.pageSize = val;
      this.searchByDrug();
    },
    // 所有药品Index发生改变
    drugCurrentChange(val) {
      this.DrugIndex = val;
      this.searchDrug();
    },
    // 团购药品Size发生改变时
    CurrentChange(val) {
      this.pageIndex = val;
      this.searchByDrug();
    },
    //上传图片
    uploadFile(params) {
      const file = params.file,
        fileType = file.type,
        isImage = fileType.indexOf("image") != -1;
      if (!isImage) {
        this.$message.error("只能上传图片格式png、jpg、gif!");
        return;
      }
      let param = new FormData(); // 创建form对象
      param.append("imgFile", file); //对应后台接收图片名  
      param.append("username", window.sessionStorage.getItem("username"));
      param.append("tokenid", window.sessionStorage.getItem("tokenid"));
      param.append("phone_uuid", window.sessionStorage.getItem("phone_uuid"));
      // 
      this.$http
        .post("Dls/UpLoadImage", param, {
          headers: {
            "Content-Type":
              "multipart/form-data;boundary =" + new Date().getTime(),
          },
        })
        .then((res) => {
          if (res.data.isok) {
            this.$message({
              type: "success",
              message: "上传成功!",
            });
            this.formByDrug.image = res.data.data;
          } else {
            this.$message.error(res.data.message);
            this.fileList = [];
          }
        });
    },
    //移除图片给提示
    handleRemove() {
      this.$message.error("图片已移除，请重新上传！");
      this.formByDrug.image = "";
    },
    // 限制上传个数
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择1张图片，本次选择了 ${files.length} 张图片，共选择了 ${
          files.length + fileList.length
        } 张图片`
      );
    },
  },
};
</script>

<style lang="less" scoped>
.el-page-header {
  margin-left: 30px;
  margin-top: 20px;
}
/deep/ .el-pagination {
  text-align: center;
  margin-top: 15px;
}
/deep/ .el-table th {
  background-color: #eef1f6;
}
/deep/ tr td {
  font-size: 12px;
}
</style>


// WEBPACK FOOTER //
// src/components/ByDrug.vue